// extracted by mini-css-extract-plugin
export default {"footerWrapper":"Footer_footerWrapper__Cn4RY","h1":"Footer_h1__Ov5a8"};